<template>
	<page>
		<module>
			<div class="order-state flex-between-center">
				<h1>状态：{{orderState}}</h1>
				<p>{{orderStateWord}}</p>
			</div>
			
			<div class="flex-between">
				<dl class="order-info">
					<dt>交易信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>订单编号：</label>
							<div class="flex-center-cross">
								{{orderDetail.order_number}}
								<div v-if="orderDetail.order_type == 5 || orderDetail.order_type == 6" class="tag" style="background: #B232FE">预售</div>
								<div v-if="orderDetail.order_type == 7" class="tag" style="background: #0066F1">定制</div>
								<a @click="$copy(orderDetail.order_number)">复制单号</a>
							</div>
						</div>
<!--						<div class="order-info-item flex">
							<label>运营模式：</label>
							<div>{{orderDetail.operation_mode==1?'平台自营':'商家自营'}}</div>
						</div>
						<div class="order-info-item flex">
							<label>所属商家：</label>
							<div>{{orderDetail.stationed_name}}</div>
						</div>-->
						<div class="order-info-item flex">
							<label>下单时间：</label>
							<div>{{orderDetail.create_date}} <!-- <a>更多</a> --></div>
						</div>
						<div class="order-info-item flex">
							<label>付款状态：</label>
							<div>{{paymentState}}</div>
						</div>
						<div class="order-info-item flex">
							<label>付款方式：</label>
							<div>{{orderDetail.payment_type?orderDetail.payment_type:'--'}}</div>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.payment_type=='转账支付'">
							<label>付款凭证：</label>
							<div><c-file media :src="orderDetail.pay_voucher_url"></c-file></div>
						</div>
					</dd>
				</dl>
				
				<dl class="order-info">
					<dt>买家信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>昵称：</label>
							<p>{{orderDetail.nick_name?orderDetail.nick_name:'--'}}</p>
						</div>
						<div class="order-info-item flex">
							<label>用户名：</label>
							<p>{{orderDetail.user_login_name}}</p>
						</div>
						<div class="order-info-item flex">
							<label>手机号码：</label>
							<p>{{orderDetail.user_manage_mobilephone}}</p>
						</div>
<!--						<div class="order-info-item flex">
							<label>所属业务员：</label>
							<p>{{orderDetail.salesman_realname?orderDetail.salesman_realname:'&#45;&#45;'}}</p>
						</div>-->
						<div class="order-info-item flex">
							<label>买家留言：</label>
							<p>{{orderDetail.order_remark?orderDetail.order_remark:'--'}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_type == 7">
							<label>定制附件：</label>
							<p class="flex">
								<template v-if="cusTomInfo.custom_attach_url">
									<c-file v-for="(item, i) in cusTomInfo.custom_attach_url.split(',')" :key="i" :src="item" media style="width: 50px; height: 50px;"></c-file>
								</template>
							</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_type == 7">
							<label>定制备注：</label>
							<p>{{cusTomInfo.custom_remark?cusTomInfo.custom_remark:'--'}}</p>
						</div>
					</dd>
				</dl>
				
				<dl class="order-info">
					<dt>物流信息</dt>
					<dd>
						<div class="order-info-item flex">
							<label>收货人：</label>
							<p>{{orderDetail.receiving_name}}，{{orderDetail.receiving_phone}}</p>
						</div>
						<div class="order-info-item flex">
							<label>收货地址：</label>
							<p>{{orderDetail.receiving_address}}</p>
						</div>
						<div class="order-info-item flex">
							<label>配送方式：</label>
							<p>{{orderDetail.logistics_company_name}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>发货时间：</label>
							<p>{{orderDetail.send_dates}}</p>
						</div>
						<div class="order-info-item flex" v-if="orderDetail.order_state == 3 || orderDetail.order_state == 5">
							<label>运单号：</label>
							<p>{{orderDetail.logistics_numbers}}</p>
						</div>
					</dd>
				</dl>

        <dl class="order-info" v-if="orderDetail.consignor_name||orderDetail.consignor_phone">
          <dt>【代发】发货人信息</dt>
          <dd>
            <div class="order-info-item flex" v-if="orderDetail.consignor_name">
              <label>发货人姓名：</label>
              <p>{{orderDetail.consignor_name?orderDetail.consignor_name:'--'}}</p>
            </div>
            <div class="order-info-item flex" v-if="orderDetail.consignor_phone">
              <label>发货人电话：</label>
              <p>{{orderDetail.consignor_phone?orderDetail.consignor_phone:'--'}}</p>
            </div>
          </dd>
        </dl>

      </div>
		</module>
		
		<module>
			<div class="order-detail">
				<c-table v-if="orderDetail" :data="productList" :paging="false" border>
					<c-table-column
						label="商品信息"
						width="300"
					>
                        <template #default="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                        </template>
					</c-table-column>
					
					<c-table-column
						label="规格名"
						width="110"
					>
						<template v-slot="{data}">
							{{data.product_sku_spec}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品SKU编码"
						width="120"
					>
						<template v-slot="{data}">
							{{data.product_sku_code?data.product_sku_code:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="成交单价"
					>
						<template v-slot="{data}">
                            ￥{{parseFloat(data.product_unit_price).toFixed(2)}}
							<font style="text-decoration: line-through;color:#999999;" v-if="data.product_unit_price!=data.original_product_price">
								<br/>
                                ￥{{orderDetail.order_type==2?data.original_product_price:parseFloat(data.original_product_price).toFixed(2)}}
							</font>
						</template>
					</c-table-column>
					
					<c-table-column
						label="数量"
						width="80"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="折扣率"
                        width="85"
						v-if="orderDetail.order_type != 2"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_unit_price*data.product_count*100/data.original_product_money).toFixed(2)}}%
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品总额"
					>
						<template v-slot="{data}">
                            ￥{{parseFloat(data.product_money).toFixed(2)}}
							<font style="text-decoration: line-through;color:#999999;" v-if="data.product_money!=data.original_product_money">
								<br/>
                                ￥ {{orderDetail.order_type==2?data.original_product_money:parseFloat(data.original_product_money).toFixed(2)}}
							</font>
						</template>
					</c-table-column>

                    <c-table-column
                            label="未发退款数"
                    >
                        <template v-slot="{data}">
                            {{data.total_refund_count}}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="已发退货数"
                    >
                        <template v-slot="{data}">
                            {{data.total_return_count}}
                        </template>
                    </c-table-column>
					
					<c-table-column
						label="重量小计(克)"
						width="100"
					>
						<template v-slot="{data}">
							{{data.product_weight?data.product_weight:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="已发货数"
						width="80"
					>
						<template v-slot="{data}">
							{{data.send_count}}
						</template>
					</c-table-column>
				</c-table>
				<div style="height:20px;"></div>
				<c-table v-if="giftProductList.length > 0" :data="giftProductList" height="auto" :paging="false" border>
					<c-table-column
						label="赠品商品信息"
						width="300"
					>
                        <template #default="{data}">
                            <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                        </template>
					</c-table-column>
					
					<c-table-column
						label="规格名"
						width="150"
					>
						<template v-slot="{data}">
							{{data.product_sku_spec}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="商品SKU编码"
						width="120"
					>
						<template v-slot="{data}">
							{{data.product_sku_code?data.product_sku_code:'--'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="数量"
						width="100"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="重量小计(克)"
						width="100"
					>
						<template v-slot="{data}">
							{{data.product_weight?data.product_weight:'--'}}
						</template>
					</c-table-column>
					
				</c-table>
				<div style="height:20px;"></div>
				<c-table v-if="cusTomList.length > 0" :data="cusTomList" height="auto" :paging="false" border>
					<c-table-column
						label="定制项"
						width="200"
					>
						<template v-slot="{data}">
							<span v-if="data.item_type==1" style="font-weight:bold;color:chocolate">{{data.custom_name}}</span>
							<span v-if="data.item_type!=1">{{data.custom_name}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制内容"
						width="260"
					>
						<template v-slot="{data}">
<!--							<template v-if="data.item_type==1 && data.custom_value">
								<div class="flex">
									<c-file v-for="(item, i) in data.custom_value.split(',')" :key="i" :src="item" media style="width: 50px; height: 50px;"></c-file>
								</div>
							</template>-->
							<span>{{data.custom_value}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制数量"
						width="80"
					>
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制费用单价"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price).toFixed(2)}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制费用小计"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price_money).toFixed(2)}}
						</template>
					</c-table-column>
					
					<!-- <c-table-column
						label="定制费用单价(报价)"
						width="140"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price_cost).toFixed(2)}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="定制费用小计(报价)"
						width="140"
					>
						<template v-slot="{data}">
							{{parseFloat(data.product_price_cost_money).toFixed(2)}}
						</template>
					</c-table-column> -->
					
				</c-table>
				<div style="height:20px;"></div>
				<c-table v-if="reducedList.length > 0" :data="reducedList" height="auto" :paging="false" border>
					<c-table-column
						label="优惠信息"
						width="400"
					>
						<template v-slot="{data}">
							{{data.remark}} {{data.reduced_money}}元
						</template>
					</c-table-column>
					
					<c-table-column
						label="优惠类型"
					>
						<template v-slot="{data}">
                            {{reducedTypeName[data.reduced_type]}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="优惠金额"
					>
						<template v-slot="{data}">
							{{data.reduced_money}}
						</template>
					</c-table-column>
				</c-table>
				
				<dl v-if="invoiceInfo" class="invoice-info">
					<dt>发票开票信息</dt>
					<dd class="flex">
						<div>
							<div v-if="invoiceInfo.invoice_type == 1" class="invoice-info-item flex">
								<label>发票类型：</label>
								<p>普通发票</p>
							</div>
							<div v-if="invoiceInfo.invoice_type == 2" class="invoice-info-item flex">
								<label>发票类型：</label>
								<p>增值税专用发票</p>
							</div>
							<div v-if="invoiceInfo.invoice_type == 3" class="invoice-info-item flex">
								<label>发票类型：</label>
								<p>增值税专用发票13%</p>
							</div>
							<div class="invoice-info-item flex">
								<label>纳税人识别号：</label>
								<p>{{invoiceInfo.tax_number}}</p>
							</div>
							<div class="invoice-info-item flex">
								<label>收票联系人：</label>
								<p>{{invoiceInfo.contact_name || '--'}}<span v-if="invoiceInfo.contact_phone">（电话：{{invoiceInfo.contact_phone}}）</span><span v-if="invoiceInfo.email">（邮箱：{{invoiceInfo.email}}）</span></p>
							</div>
							<div class="invoice-info-item flex">
								<label>收票地址：</label>
								<p>{{invoiceAddress || '--'}}</p>
							</div>
						</div>
						<div class="flex-grow">
							<div class="invoice-info-item flex">
								<label>发票抬头：</label>
								<p>{{invoiceInfo.invoice_title}}</p>
							</div>
							<div v-if="invoiceInfo.invoice_type != 1"  class="invoice-info-item flex">
								<label>开户行账号：</label>
								<p>{{invoiceInfo.bank_account}}（开户行{{invoiceInfo.bank_name}}）</p>
							</div>
							<div v-if="invoiceInfo.invoice_type != 1" class="invoice-info-item flex">
								<label>开票地址：</label>
								<p>{{invoiceInfo.kp_address || '--'}}</p>
							</div>
							<div v-if="invoiceInfo.invoice_type != 1" class="invoice-info-item flex">
								<label>开票电话：</label>
								<p>{{invoiceInfo.kp_phone || '--'}}</p>
							</div>
						</div>
                        <div class="flex-grow">
                            <div class="invoice-info-item flex">
                                <label>开票状态：</label>
                                <p>{{orderDetail.invoice_state == 2 ? '已开票':'未开票'}}</p>
                            </div>
                            <div v-if="orderDetail.invoice_state == 2"  class="invoice-info-item flex">
                                <label>开票完成时间：</label>
                                <p>{{orderDetail.invoice_date}}</p>
                            </div>
                            <div v-if="orderDetail.invoice_state == 2"  class="invoice-info-item flex">
                                <label>开票实收金额：</label>
                                <p>{{parseFloat(orderDetail.reality_money).toFixed(2)}}</p>
                            </div>
                            <div v-if="orderDetail.invoice_state == 2"  class="invoice-info-item flex">
                                <label>开票凭证：</label>
                                <p>
                                    <a :href="orderDetail.invoice_file" target="_blank">{{orderDetail.invoice_file}}</a>
                                </p>
                            </div>
                        </div>
					</dd>
				</dl>
				
				<div class="order-total flex-between-center">
					<div>商品总额 ￥{{parseFloat(orderDetail.product_money).toFixed(2)}}<span v-if="orderDetail.order_type==7">，定制费用 ￥{{parseFloat(cusTomInfo.product_price_money).toFixed(2)}}</span>，运费 ￥{{parseFloat(orderDetail.logistics_money).toFixed(2)}}，其他收费￥{{parseFloat(orderDetail.total_fee_money).toFixed(2)}}</div>
					<div>{{orderDetail.payment_state == 1 ? '应付':'实付'}}总额：<span><b>￥{{paymentTotal}}</b></span></div>
				</div>
			</div>
		</module>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	
	export default {
		components: {
			productInfo
		},
		
		props: {
			orderNumber: String
		},
		
		data() {
			return {
				orderDetail: '',
				productList: [],
				giftProductList: [],
				reducedList: [],
				cusTomList: [],
				cusTomInfo:'',
				invoiceInfo:'',
				invoiceDate:'',
				realityMoney: 0,
				sendList: [],
				editList: [],
				lastLogisticsCompany: '',
				logisticsCompany: [],
				sendNum: {},
				orderRemark: '',
				remarkList: [],
				rejectReason: '',
				cancel_reason: '',
				order_remark: '',
				pack_info:[],
				new_logistics_money: 0,
				old_money: 0,
		        invoice_file_type:'',//开票文件类型
		        invoice_file:'',//发票文件
		        text_msg:'',
                reducedTypeName: {
                    0: '升级礼包优惠',
                    1: '优惠券优惠',
                    2: '限时折扣活动优惠',
                    3: '代理等级折扣优惠',
                    4: '砍价活动优惠',
                    5: '抽奖奖品优惠',
                    6: '积分抵扣',
                    7: '秒杀活动优惠',
                    8: '预售活动优惠',
                    9: '拼团活动优惠',
                    10: '特殊价格优惠',
                    11: '新人活动',
                    12: '储值送优惠',
                    13: '搭配购优惠',
                    14: '一元购优惠',
                    99: '订单调价'
                }
			}
		},
		
		computed: {
			orderState() {
				var msg = "";
				if (this.orderDetail.refunding_count > 0){
				  msg = "订单申请【仅退款】";
				}else if (this.orderDetail.returning_count > 0){
				  msg = "订单申请【退货】";
				}else {
				  msg = {
					1: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason +')':'等待买家付款',
					2: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason +')':'买家已付款，等待商家发货',
					3: '已' + this.orderDetail.deliver_state + (this.orderDetail.deliver_state=='全部发货' ? '，待买家确认收货':'，还有部分货品未发'),
					5: '交易已完成',
					6: this.orderDetail.check_state == 3 ? '审核不通过':'订单已取消'
				  }[this.orderDetail.order_state];
				}
				return msg;
			},
			orderStateWord() {
			    var msg = "";
			    if (this.orderDetail.refunding_count > 0){
                    msg = "订单存在【仅退款】申请，请先处理完成后再进行其他操作";
		        }else if (this.orderDetail.returning_count > 0){
		            msg = "订单存在【退货】申请，请先处理完成后再进行其他操作";
		        }else {
					if(this.orderDetail.order_state == 1 && this.orderDetail.payment_state == 2){
						msg = "等待买家支付尾款";
					}else{
					  msg = {
						  1:  this.orderDetail.payment_type == '转账支付' ? '当前订单使用转账支付方式支付，请及时审核':'请在 ' + this.orderDetail.last_pay_date + ' 之前完成支付，否则订单将自动取消',
						  // 1:  '请尽快通知客户完成付款（1、客户自行付款，2、销售内勤使用授信挂账审批通过，3、销售内勤执行审批不通过）',
						  2: '买家已付款，请尽快发货',
						  3: (this.orderDetail.deliver_state=='全部发货' ? '如客户未确认收货，订单将于' + this.orderDetail.last_confirm_date + '自动确认收货':''),
						  5: '完结时间：' + this.orderDetail.confirm_date,
						  6: '取消原因：' + (this.orderDetail.cancel_reason_type_name ? this.orderDetail.cancel_reason_type_name:'') + (this.orderDetail.cancel_reason ? '（' + this.orderDetail.cancel_reason + '）':'')
					  }[this.orderDetail.order_state];
					}
		        }
				return msg;
			},
			
			paymentState() {
				return {
					1: '待付款',
					2: '待付尾款',
					3: '已付款'
				}[this.orderDetail.payment_state];
			},
			
			paymentTotal() {
				if(this.orderDetail.order_type == 7 ){
					return this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money).toFixed(2):(this.orderDetail.product_money + this.cusTomInfo.product_price_money+ this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
				}else{
					return this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money).toFixed(2):(this.orderDetail.product_money + this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
				}
			},
			

			invoiceAddress() {
				if (!this.invoiceInfo) return '';
				return (this.invoiceInfo.address_province_name || '') + (this.invoiceInfo.address_city_name || '') + (this.invoiceInfo.address_county_name || '') + (this.invoiceInfo.address_details || '');
			}
		},
		
		watch: {
			orderNumber() {
				this.getOrderDetail();
			}
		},
		
		mounted() {
			this.getOrderDetail();
		},
		
		methods: {
			//获取订单详情数据
			getOrderDetail() {
				this.request({
					url: '/order/detail',
					data: {
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.orderDetail = data.base_info;
						this.order_remark = this.orderDetail.order_remark;
						this.productList = data.product_sku_info;
						this.giftProductList = data.gift_product_list;
						this.reducedList = data.reduced_list;
						this.cusTomList = data.custom_list||[];
						this.cusTomInfo = data.custom_info||{};
						this.invoiceInfo = data.invoice_info;
						this.pack_info = data.pack_info;
						this.old_money = this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money).toFixed(2):(this.orderDetail.product_money  + (this.cusTomInfo.product_price_money||0) + this.orderDetail.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		&-state {
			height: 120px;
			padding: 0 34px;
			font-size: 13px;
			color: #fff;
			background: #005CD9;
			background-image: url('~@/assets/image/order_detail_state_bg.png');
			background-size: 100% auto;
			background-position: left bottom;
			background-repeat: no-repeat;
			
			h1 {
				font-size: 24px;
			}
		}
		
		&-info {
			width: 500px;
			padding: 30px 30px;
			
			dt {
				border-left: 3px solid #000;
				padding-left: 5px;
				margin-bottom: 26px;
				line-height: 18px;
				font-size: 16px;
				font-weight: bold;
			}
			
			&-item {
				padding: 9px 0;
				line-height: 20px;
				font-size: 13px;
				
				label {
					min-width: 5em;
					color: #666;
					text-align: right;
				}
				
				> div {
					.tag {
						border-radius: 2px;
						padding: 0 5px;
						margin-left: 6px;
						line-height: 18px;
						color: #fff;
					}
					
					a {
						margin-left: 6px;
						color: #005CD9;
					}
				}
			}
		}
		
		&-detail {
			padding: 30px 30px 40px;
		}
		
		&-total {
			height: 45px;
			padding: 0 16px;
			font-size: 13px;
			color: #000;
			background: #FAFAFA;
			
			span {
				color: var(--color-main);
			}
			
			b {
				font-size: 16px;
			}
		}
		
		&-remark {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}

	.logistics {
		&-order {
			padding: 14px 18px;
			
			li {
				border: 1px solid #ddd;
				padding: 0 26px;
				line-height: 42px;
				font-size: 14px;
				color: #666;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 20px;
				}
				
				&:hover {
					background: #F0F3FC;
				}
				
				&.z-crt {
					border-color: #005CD9;
					color: #005CD9;
					background: #F0F3FC;
				}
			}
		}
		
		&-list {
			height: 434px;
			padding: 20px;
			overflow: auto;
			background: #FAFAFA;
			
			li {
				padding: 10px 0;
				line-height: 24px;
				font-size: 13px;
				color: #333;
				
				label {
					margin-right: 16px;
					color: #666;
				}
			}
		}
	}
	.invoice-info {
		max-width: 1000px;
		padding: 30px 0;
		
		dt {
			border-left: 3px solid #000;
			padding-left: 5px;
			margin-bottom: 26px;
			line-height: 18px;
			font-size: 16px;
			font-weight: bold;
		}
		
		dd > div:nth-child(1) {
			margin-right 50px;
		}
		
		&-item {
			padding: 9px 0;
			line-height: 20px;
			font-size: 13px;
			
			label {
				min-width: 7em;
				color: #666;
				text-align: right;
			}
			
			p {
				a {
					color: #005CD9;
				}
			}
		}
	}
	
	.invoice {
		font-size: 14px;
		color: #000;
		
		p {
			color:#666;
			height:30px;
		}
	}
</style>